import { ConstellationOneListing, getLotAreaInSqft } from '@aloft/toolkit-shared';

export const getLotAreaSqftString = (listingData: ConstellationOneListing): string | undefined =>
  getLotAreaInSqft(listingData)?.unitAmount.toLocaleString('en-US');
